import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const BoardStats = /*#__PURE__*/ memo((param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("flex items-center gap-1 text-12 font-medium text-grey-11", className),
        ...restOfProps
    });
});
BoardStats.displayName = "BoardStats";
